import { TermsOfServiceContent } from '../components/TermsOfServiceModal';
export { termsHandle as handle } from '../routeMetadata';

import { TAN_BG } from '../data/constants';

export default function Terms() {
  return (
    <div
      className="px-4 py-8"
      style={{ backgroundColor: TAN_BG }}
    >
      <h1
        className="text-3xl font-bold mb-6 text-center"
      >
        Terms of Service
      </h1>
      <TermsOfServiceContent />
    </div>
  );
}
